import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { ClipboardCheck, ScrollText } from "lucide-react";
import { PageHeader } from "../../components/common";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../components/ui/tabs";
import { Card, CardContent } from "../../components/ui/card";
import { SafQueue } from "../../components/saf/SafQueue";
import { SafCaseDialog } from "../../components/saf/SafCaseDialog";
import { SafLogReport } from "../../components/saf/SafLogReport";
import { getAuth } from "../../lib/api";

/**
 * Phase 207 — Supervisor: SAF Reviews.
 *  Reviews tab: citizen self-assessments in the supervisor's wards that the Field Collector has verified — modify demand lines,
 *  approve (forwards to the Municipal Admin) or send back for correction.
 *  Approval Log tab: the SAF Approval and Modification Log scoped to the supervisor's territory (Excel export).
 */
export default function SafReviews() {
  const { code } = useParams();
  const role = getAuth()?.user?.role === "municipal_admin" ? "municipal_admin" : "supervisor";
  const [tab, setTab] = useState("reviews");
  const [open, setOpen] = useState(null);
  const [reloadKey, setReloadKey] = useState(0);
  return (
    <div data-testid="supervisor-saf-reviews-page">
      <PageHeader title="SAF Reviews"
        subtitle="Citizen self-assessments verified on site by your Field Collectors — review, modify the demand if required, approve or send back. Every action is kept in the approval log." />
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList>
          <TabsTrigger value="reviews" data-testid="saf-reviews-tab-reviews"><ClipboardCheck className="h-3.5 w-3.5 mr-1.5" /> Reviews</TabsTrigger>
          <TabsTrigger value="log" data-testid="saf-reviews-tab-log"><ScrollText className="h-3.5 w-3.5 mr-1.5" /> Approval Log</TabsTrigger>
        </TabsList>
        <TabsContent value="reviews" className="mt-4">
          <Card className="shadow-sm">
            <CardContent className="p-4">
              <SafQueue code={code} onOpen={setOpen} reloadKey={reloadKey} testIdPrefix="sup-saf" pendingLabel="Pending my review" limit={10} />
            </CardContent>
          </Card>
          <p className="text-xs text-muted-foreground mt-3">
            Only self-assessments in your mapped wards are listed. Approving forwards the case to the Municipal Admin for final approval and PIN generation.
          </p>
        </TabsContent>
        <TabsContent value="log" className="mt-4">
          <SafLogReport code={code} testId="sup-saf-log" scopedNote="Scoped to your territory — only self-assessments in your mapped wards appear here." />
        </TabsContent>
      </Tabs>
      <SafCaseDialog code={code} saf={open} role={role} open={!!open} onClose={() => setOpen(null)} onChanged={() => setReloadKey((k) => k + 1)} testIdPrefix="sup-saf-case" />
    </div>
  );
}
